import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="bg-navy-900 py-24 relative overflow-hidden" data-id="element-74">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-30" data-id="element-75"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-77">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-cream italic leading-tight mb-10" data-id="element-78">
            "Have you ever felt like the world is designed only for couples,
            while you're trying to figure out how to protect your own future?"
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-6 text-lg sm:text-xl text-cream-warm/80 font-light leading-relaxed" data-id="element-79">
          <p data-id="element-80">
            It's not just about being single. It's about the uncertainty. That
            silent question that appears when the lights go off:{' '}
            <span className="text-gold font-medium" data-id="element-81">
              "Am I truly prepared? Do I have a solid plan for myself?"
            </span>
          </p>

          <p data-id="element-82">
            Most advice tells you to "find someone" to feel protected. We
            believe the opposite:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-12 p-8 border border-gold/30 bg-navy-800/50 rounded-lg shadow-2xl" data-id="element-83">
          <p className="text-xl sm:text-2xl font-serif text-gold font-medium leading-relaxed" data-id="element-84">
            True peace of mind comes from knowing you are perfectly capable of
            taking care of yourself, financially and emotionally.
          </p>
          <p className="mt-4 text-cream uppercase tracking-widest text-sm font-semibold" data-id="element-85">
            Welcome to a new era of radical confidence.
          </p>
        </motion.div>
      </div>
    </section>;
}